// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1mgoT","label":"styles_label__27a6m"};